import { Email, PhoneNumber } from "../form";
import { FullName, Locks, OnlineContactDetails, QRWaiterContactDetails, } from "../ordering";
export const CONTACT_DETAILS_KEY = "client_contactDetails";
export class ContactDetailsStorageManager {
    constructor(validatePhoneService) {
        this.validatePhoneService = validatePhoneService;
    }
    store(contactDetails) {
        let contactDetailsData;
        if (contactDetails.type === "Online") {
            contactDetailsData = {
                type: "Online",
                fullName: contactDetails.fullName.value,
                email: contactDetails.email.value,
                phoneNumber: contactDetails.phone.value,
                phoneCountry: contactDetails.phone.country,
            };
        }
        else {
            contactDetailsData = {
                type: "QrWaiter",
                email: contactDetails.email.value,
            };
        }
        const contactDetailsDataString = JSON.stringify(contactDetailsData);
        localStorage.setItem(CONTACT_DETAILS_KEY, contactDetailsDataString);
    }
    restore() {
        var _a;
        const contactDetailsDataString = localStorage.getItem(CONTACT_DETAILS_KEY);
        if (contactDetailsDataString === null) {
            return null;
        }
        const contactDetailsData = JSON.parse(contactDetailsDataString);
        if (contactDetailsData.type === "Online") {
            return new OnlineContactDetails({
                locks: new Locks(),
                validatePhoneService: this.validatePhoneService,
                email: new Email(contactDetailsData.email),
                fullName: new FullName(contactDetailsData.fullName),
                phone: new PhoneNumber(contactDetailsData.phoneNumber, (_a = contactDetailsData.phoneCountry) !== null && _a !== void 0 ? _a : "PL", this.validatePhoneService),
            });
        }
        else {
            return new QRWaiterContactDetails({
                locks: new Locks(),
                email: new Email(contactDetailsData.email),
            });
        }
    }
}
